/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Col_WarehouseInputs */

const vi_stocktake_line_col_warehouse = /** @type {(inputs: Stocktake_Line_Col_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho`)
};

/**

* @param {Stocktake_Line_Col_WarehouseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_col_warehouse = /** @type {((inputs?: Stocktake_Line_Col_WarehouseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Col_WarehouseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_col_warehouse(inputs)
});